import React from "react";
import { Moon, Sun } from "lucide-react";
import styles from "./ThemeSwitch.module.scss";

interface ThemeSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ThemeSwitch: React.FC<ThemeSwitchProps> = ({ checked, onChange }) => {
  return (
    <div
      className={`${styles.themeSwitchWrapper} ${checked ? styles.dark : styles.light}`}
      onClick={() => onChange(!checked)}
      role="switch"
      aria-checked={checked}
      tabIndex={0}
      style={{ width: 44, height: 24 }}
    >
      <span
        className={styles.thumb}
        style={{
          width: 20,
          height: 20,
          top: 2,
          left: checked ? 22 : 2,
          transition: "left 0.2s cubic-bezier(0.4,0,0.2,1)"
        }}
      >
        {checked ? <Moon size={14} color="#0C3451" /> : <Sun size={14} color="#0C3451" />}
      </span>
    </div>
  );
};

export default ThemeSwitch;
